import React from "react";
import Icon from "@ant-design/icons";

const DashboardSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H5.50001C6.32843 2.5 7.00001 3.17157 7.00001 4V5.50001C7.00001 6.32843 6.32843 7.00001 5.50001 7.00001H4C3.17157 7.00001 2.5 6.32843 2.5 5.50001V4Z"
			stroke="#344054"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 10.5C2.5 9.67159 3.17157 9.00001 4 9.00001H5.50001C6.32843 9.00001 7.00001 9.67159 7.00001 10.5V12C7.00001 12.8284 6.32843 13.5 5.50001 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V10.5Z"
			stroke="#344054"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.00001 4C9.00001 3.17157 9.67159 2.5 10.5 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V5.50001C13.5 6.32843 12.8284 7.00001 12 7.00001H10.5C9.67159 7.00001 9.00001 6.32843 9.00001 5.50001V4Z"
			stroke="#344054"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.00001 10.5C9.00001 9.67159 9.67159 9.00001 10.5 9.00001H12C12.8284 9.00001 13.5 9.67159 13.5 10.5V12C13.5 12.8284 12.8284 13.5 12 13.5H10.5C9.67159 13.5 9.00001 12.8284 9.00001 12V10.5Z"
			stroke="#344054"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const DashboardIcon = (props) => (
	<Icon component={() => <DashboardSvg {...props} />} />
);

export default DashboardIcon;
